import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';
import Show from './Show.vue';
import { PAPEIS_DO_POWER_DATA } from './acesso';

// Repetido no registro SOLTO de propósito. A tela da BASE não é mais filha do
// SettingsWrapper, e o guard (`validateAuthenticateRoutePermission`) lê tudo isto de
// `to.matched` — um registro solto não herda nada. Sem a cópia, o bloco de acesso some
// inteiro e a base abre para quem o servidor não deixa entrar, sem erro em lugar nenhum.
//
// `permissions` também é lido fora do guard: o `resolvePermissions` do provider da sidebar
// faz `router.resolve(to).meta.permissions` para decidir se mostra o item.
//
// Sem flag desde 30/09/2026 (POWERDATA-ACESSO-01): o PowerData vale para toda conta, e é o
// papel que abre a porta. Saíram `superAdminOrFlag` e `featureFlag`, que deixavam o
// administrador e o atendente de fora da conta sem a flag `power_data`.
//
// ACESSO-01 (L8b): com a chave ACESSO_GRANULAR ligada, a lista e a base pedem o `powerdata:read` (`power_data#index`,
// `#show`), e cuidar das fontes e criar base, o `write` e o `manage`, que a tela confere.
const ACESSO = {
  permissions: PAPEIS_DO_POWER_DATA,
  escopos: ['powerdata:read'],
};

// A LISTA fica no shell; a BASE ocupa a viewport. É o mesmo desenho dos PowerApps, e foi
// escolha do Murilo (14/09): a lista é uma tela de configuração como as outras, e a base é
// um lugar em que se ENTRA — tabela de milhares de linhas, abas próprias, fluxo próprio.
// Sair da base e voltar para o shell é a mesma troca de moldura que sair de um PowerApp,
// e é ela que diz "terminei aqui".
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/power-data'),
      meta: { ...ACESSO },
      component: SettingsWrapper,
      props: {
        headerTitle: 'POWER_DATA.TITLE',
        icon: 'i-lucide-database',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'power_data_index',
          component: Index,
          // A cópia aqui não é enfeite: o filho sobrepõe o `meta` do pai, e o provider da
          // sidebar, quando chega pelo `navigationPath`, lê o registro deste nome sem herança.
          meta: { ...ACESSO },
        },
      ],
    },
  ],
  standaloneRoutes: [
    {
      path: frontendURL('accounts/:accountId/settings/power-data/:storeId'),
      name: 'power_data_show',
      component: Show,
      meta: { ...ACESSO },
    },
  ],
};
